import React from "react";
import ImageInput from "./ImageInput";
import { resolveDocumentUrl } from "utils/documentUtils";
import styles from "../Form.module.scss";

const isAppWebView = () =>
  window.localStorage.getItem("referrer_platform") === "app";

function DocumentPreviewInput({ substep, value, onChange, error, isReadOnly, pdfPath, fileName, allowedExtensions }) {
  const documentUrl = resolveDocumentUrl(pdfPath);

  const handlePreview = (e) => {
    if (!documentUrl) { e.preventDefault(); return; }
    if (isAppWebView() && window.openDocumentHandler) {
      e.preventDefault();
      window.openDocumentHandler.postMessage(
        JSON.stringify({ url: documentUrl, title: fileName, showDownload: true })
      );
    }
  };

  return (
    <div className={styles.fieldBody}>
      <a
        className={styles.docPreviewLink}
        href={documentUrl || undefined}
        target="_blank"
        rel="noreferrer"
        onClick={handlePreview}
      >
        <img className={styles.docPreviewIcon} src="/logos/note_book_icon.png" alt="" />
        <span className={styles.docPreviewName}>{fileName}</span>
        <span className={styles.docPreviewOpen}>Download</span>
      </a>

      <div className={styles.docUploadLabel}>Upload signed copy</div>

      <ImageInput
        substep={substep}
        value={value}
        onChange={onChange}
        error={error}
        isReadOnly={isReadOnly}
        allowedExtensions={allowedExtensions}
      />
    </div>
  );
}

export default DocumentPreviewInput;
